import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: null,
  error: "",
  message: "",
};

export const deleteUserOfferAttemptAction = createAsyncThunk(
  "delete-user-offer-attempt",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.delete(`/admins/api/deleteUserOfferAttempt`, {
        data: { attemptId: data.attemptId }
      });
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteUserOfferAttemptSlice = createSlice({
  name: "delete-user-offer-attempt",
  initialState,
  reducers: {
    resetDeleteUserOfferAttemptState: (state) => {
      state.status = null;
      state.loading = false;
      state.data = null;
      state.error = "";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(deleteUserOfferAttemptAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteUserOfferAttemptAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(deleteUserOfferAttemptAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const { resetDeleteUserOfferAttemptState } = deleteUserOfferAttemptSlice.actions;
export const deleteUserOfferAttemptReducer = deleteUserOfferAttemptSlice.reducer;
